import Yup from '~/util/yup';
import { getInitialValues } from '~/libraries/forms/values';
import { generateValidationSchema } from '~/libraries/forms/validation';
import { Form } from '~/shared/forms/Form';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';
import { PredefinedGoalFormFields } from '../../goals/PredefinedGoalFormFields';

export function CapturePredefinedGoalStep() {
	const { wizardState } = useGoalsAndInterventionsWizard();
	if (!wizardState.selectedGoal || wizardState.selectedGoal.type !== 'predefined' || !wizardState.selectedGoal.fullGoalDefinition) {
		throw new Error('PredefinedGoalForm can only be used when the selectedGoal is of type "predefined" and has a fullGoalDefinition');
	}
	const fullGoalDefinition = wizardState.selectedGoal.fullGoalDefinition;

	const initialValues = wizardState.selectedGoal.formValues
		? wizardState.selectedGoal.formValues
		: getInitialValues(fullGoalDefinition.definitionFormFields)!;
	const validationSchema = Yup.object().shape(generateValidationSchema(fullGoalDefinition.definitionFormFields) || {});

	return (
		<Form initialValues={initialValues} validationSchema={validationSchema} registryId={wizardState.selectedGoal.newGoalId}>
			<PredefinedGoalFormFields fullGoalDefinition={fullGoalDefinition} />
		</Form>
	);
}
